import { createActionCreators, createReducerFunction, ImmerReducer } from 'immer-reducer';
import { IBaseViewState } from '../../interfaces/states/BaseViewState';

const initialState: IBaseViewState = {
  checkoutButtonDisabled: false,
  pluMenuDisabled: false,
  searchLockAndMiddleButtonDisabled: false,
  sidebarDisabled: false,
};

class BaseViewReducer extends ImmerReducer<IBaseViewState> {
  public setState(state: Partial<IBaseViewState>): void {
    this.draftState = { ...this.draftState, ...state };
  }

  public resetState() {
    this.draftState = initialState;
  }
}

export const BaseViewActions = createActionCreators(BaseViewReducer);
export const BaseViewReducerFunction = createReducerFunction(BaseViewReducer, initialState);
